import React from "react";
import { LifeAtBaseButtonProps, LifeAtButtonV2 } from "@common/LifeAtButtonV2/LifeAtButtonV2";
import Styles from "@themes/Styles";

interface CheckoutButtonProps extends LifeAtBaseButtonProps {
    readonly isActive?: boolean;
}

export default function CheckoutButton(props: CheckoutButtonProps) {
    return props.isActive ? (
        <LifeAtButtonV2
            variant={"solid"}
            overrideBackgroundColor={Styles.buttonFillBlue}
            overrideTextColor={"#FFFFFF"}
            disableHover={true}
            {...props}
        >
            {props.children}
        </LifeAtButtonV2>
    ) : (
        <LifeAtButtonV2 variant={"outline"} disableHover={true} {...props}>
            {props.children}
        </LifeAtButtonV2>
    );
}
